<template>
    <form class="space-y-4">
      <div>
        <label class="block text-left text-gray-700 font-medium">{{ $t('contactForm.nameLabel') }}</label>
        <input type="text" class="w-full mt-1 p-3 border rounded-lg focus:ring-2 focus:ring-[#49beb7]" :placeholder="$t('contactForm.namePlaceholder')" required />
      </div>

      <div>
        <label class="block text-left text-gray-700 font-medium">{{ $t('contactForm.emailLabel') }}</label>
        <input type="email" class="w-full mt-1 p-3 border rounded-lg focus:ring-2 focus:ring-[#49beb7]" :placeholder="$t('contactForm.emailPlaceholder')" required />
      </div>

      <div>
        <label class="block text-left text-gray-700 font-medium">{{ $t('contactForm.messageLabel') }}</label>
        <textarea class="w-full mt-1 p-3 border rounded-lg focus:ring-2 focus:ring-[#49beb7]" rows="5" :placeholder="$t('contactForm.messagePlaceholder')" required></textarea>
      </div>

      <button type="submit" class="w-full bg-paletteDarkGreen text-white py-3 rounded-lg font-semibold hover:bg-[#d94d4d] transition">
        {{ $t('contactForm.submitButton') }}
      </button>
    </form>
</template>

<script>
export default {
  name: 'ContactForm'
}
</script>
